<template>
  <section>
    <div>
      <div class="logo mb-3">
        <router-link  class="navbar-item logo" style="font-family: UnisansBoldItalic; font-size: 3rem; text-decoration: none; border-bottom: unset; outline: none" to="/">
          <!--        <img src="../../assets/crewhr.png" width="80">-->
          <span style="font-family: UnisansBoldItalic;color: #d51317">
                    core
                </span>
          <span style="font-family: UnisansBoldItalic; color: rgb(0, 0, 0.7)">
                     crewbox
                </span>
        </router-link>
      </div>
      <div class="card" style="width: 23rem;">
        <div class="card-body">
          <div class="row">
            <div class="col-4 text-start mb-1">
              <b style="font-size: small">Email</b>
            </div>
            <div class="input-group mb-3">
        <span class="input-group-text" id="basic-addon1">
            <font-awesome-icon icon="envelope" style="height: 25px"/>
          </span>
              <input type="email" class="form-control" placeholder="Mail" aria-label="Username" aria-describedby="basic-addon1" v-model="username">
            </div>
            <div class="col-4 text-start mb-1">
              <b style="font-size: small">Password</b>
            </div>
            <div class="input-group mb-3">
        <span class="input-group-text" id="basic-addon1">
            <font-awesome-icon icon="key" style="height: 25px"/>
          </span>
              <input type="password" class="form-control" placeholder="Password" aria-label="Username" aria-describedby="basic-addon1" v-model="password">
            </div>
            <div class="col-12">
              <button type="button" class="btn btn-success" style="width: 20.9rem" @click="tryLogin">Login</button>
            </div>
          </div>
        </div>
      </div>
    </div>

  </section>
</template>

<script>
  import {createNamespacedHelpers} from 'vuex';
  //import {loadingMixin} from "@/utils/mixins.js";

  const {mapActions,mapState} = createNamespacedHelpers('auth');

  export default {
    name: "LoginPage",
    //mixins: [loadingMixin],
    async created()
    {
      try
      {
        //
      }
      catch(e)
      {
        this.$notify({title: "Error", text:"Couldn't access CrewBox server. Please check your internet connection."+e.message , type: "error"});
      }
    },

    methods:
            {


             ...mapActions(["auth","login"]),

              async tryLogin() {
                //this.showLoading();
                try {
                  await this.login({email: this.email, password: this.password});

                  this.$notify({title: "Success", text: "You have just logged in successfully.", type: "success",});

                } catch (e) {

                  this.$notify({title: "Error", text:"Error on tryLogin function e: " + e.response.data +".", type: "error"});
                } finally {

                //  this.hideLoading();

                }
              }

            },

    computed:
            {
              ...mapState(["user"]),
              email()
              {
                // return `${this.username}@corendon-airlines.com`;
                return `${this.username}`;
              }
            },

    data()
    {
      return {
        username: '',
        password: '',
      }
    }

  }
</script>

<style>
section {
  min-height: 100vh;
  background-color: #f5f5f5;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
